import { OdometerConfigurationModel, TwoFAConfigModel } from "../../instance/models/instance.model";
import { CustomeTripQuestion } from "../../pre-post-trip-question/models/custom-question.model";

export class SharedVehicleGroupModel {
  public sharedvehiclegroupHashId: string;
  public sharedVehicleGroupDriverHashId: string;
  public sharedVehicleGroupMappingHashId: string;
  public sharedVehicleSubscriptionHashId: string;
  public organizationName: string;
  public groupName: string;
  public companyName: string;
  public companyMasterHashId: string;
  public vehicleMasterHashId: string;

  public bookingInterval: string;
  public preBookingInterval: string;
  public postBookingInterval: string;
  public bookingMinDuration: string;
  public bookingMaxDuration: string;
  public maxRecurringBooking: string;
  public bookingExtensionTime: string;
  public adminCount: number;

  //WEGO2DEV-325(Settings for Dashboard statuses)
  // public locationVehicleTime : number;
  // public locationTimeInterval : string = "";
  // public bookedBeforeTime : number;
  // public bookedBeforeInterval : string = "";

  // public groupGeoLocationAddress: string;
  // public groupGeoLocationLatitude: number;
  // public groupGeoLocationLongitude: number;

  public isChecked: boolean;
  public subScription: string;
  public isDefualt: boolean;
  public subScriptionEndDate: string;
  listOfSubscription: SharedVehicleSubscription[];
  public subscriptionStartDatetime: string;
  public subscriptionEndDatetime: string;
  public isActive: boolean;

  public isBookingIntervalAlignToCalendar: boolean = false;
  public selectedSubscription: string;
  public isGefenceEnabled: boolean = false;
  public geofenceAttributeModel: GeofenceAttributeModel;
  public homeLocationModel: HomeLocationModel;
  public isHomeLocationEnabled: boolean;
  public isOdometerConfiguration: boolean = false;
  public odometerConfigurationModel: OdometerConfigurationModel;
  public earlyOpenInterval: number;
  public showVehicleChargeLevel: string = "NO";
  public bookingRunningNotification: BookingRunningNotification;
  public isSubscriptionEditEnable: boolean;
  public organizationMasterHashId: string;
  public selectedOrganizationSubscription: string;

  public isEditable: boolean;
  public isDeletable: boolean;
  public isAdminCount: boolean;
  public isVehicleCount: boolean;
  public isDriverCount: boolean;
  public isContractTypeGroupCount: boolean;
  public isSubscriptionCount: boolean;
  public isSubscriptionDeletable: boolean;
  public markedForDeletion: boolean;
  public customTripQuestionList: Array<CustomeTripQuestion>;
  public instanceLanguage: string='en';
  public twoFAConfig: TwoFAConfigModel;
  public createBookingDisabled: boolean;
  public editBookingDisabled: boolean;
  public licenseCheckEnabled: boolean;
  public bookingLicenseCheckEnabled: boolean;
  public trackAndTraceEnabled: boolean;
  public isAccessCardsEnabled: boolean = false;
  
  constructor() {
    this.geofenceAttributeModel = new GeofenceAttributeModel();
    this.homeLocationModel = new HomeLocationModel();
    this.odometerConfigurationModel = new OdometerConfigurationModel();
    this.bookingRunningNotification = new BookingRunningNotification();
    this.customTripQuestionList = new Array<CustomeTripQuestion>();
    this.twoFAConfig = new TwoFAConfigModel();
  }
}

export class SharedVehicleSubscription {
  public sharedVehicleSubscriptionHashId: string;
  public organizationSubscriptionHashId: string;
  public name: string;
}
export class GeofenceAttributeModel {
  public address: string;
  public latitude: string;
  public longitude: string;
  public radiusInMtr: string;
}

export class HomeLocationModel {
  public address: string;
  public latitude: string;
  public longitude: string;
  public radiusInMtr: string;
}

export class BookingRunningNotification {
  public enableNotification: boolean = false;
  public notifyAfterMinutes: number;
  public notificationInterval: number;
  public companyAdmin: boolean;
  public groupAdmin: boolean;
  public organizationAdmin: boolean;
  public driver: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroup/models/sharedvehiclegroup.model.ts